import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthProvider";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/home", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const r = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (r.ok) {
          const user = await r.json();
          // Clear hash then navigate
          window.history.replaceState(null, "", window.location.pathname);
          if (refresh) await refresh();
          nav("/home", { replace: true, state: { user } });
        } else {
          nav("/home", { replace: true });
        }
      } catch {
        nav("/home", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen spotlight grain flex items-center justify-center">
      <div className="text-center">
        <div className="font-display text-3xl text-[#FDFBF7]">Signing you in…</div>
        <div className="mt-2 text-xs tracking-[0.3em] uppercase text-[#00E5FF]">One sec</div>
      </div>
    </div>
  );
}
